import React from 'react';
import '../styles/pages/Locations.css';

const Locations = () => {
  const locations = [
    {
      name: 'Lake Conroe',
      address: '15260 Highway 105 W Suite 116',
      city: 'Montgomery',
      state: 'TX',
      zip: '77356',
      phone: '(936) 588-7070',
      hours: {
        'Monday-Thursday': '11:00 AM - 10:00 PM',
        'Friday-Saturday': '11:00 AM - 11:00 PM',
        'Sunday': '11:00 AM - 9:00 PM'
      },
      mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3446.1076413976897!2d-95.5662533!3d30.2568348!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x86473a7eadb6f0e3%3A0xb5f9dd5f5aa12797!2s15260%20TX-105%2C%20Montgomery%2C%20TX%2077356!5e0!3m2!1sen!2sus!4v1648132133358!5m2!1sen!2sus'
    },
    {
      name: 'The Woodlands',
      address: '3335 College Park Dr',
      city: 'The Woodlands',
      state: 'TX',
      zip: '77384',
      phone: '(936) 271-2200',
      hours: {
        'Monday-Thursday': '11:00 AM - 10:00 PM',
        'Friday-Saturday': '11:00 AM - 11:00 PM',
        'Sunday': '11:00 AM - 9:00 PM'
      },
      mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3447.8901123123123!2d-95.4562533!3d30.1568348!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x86473a7eadb6f0e3%3A0xb5f9dd5f5aa12797!2s3335%20College%20Park%20Dr%2C%20The%20Woodlands%2C%20TX%2077384!5e0!3m2!1sen!2sus!4v1648132133358!5m2!1sen!2sus'
    },
    {
      name: 'Spring',
      address: '21420 Kuykendahl Rd',
      city: 'Spring',
      state: 'TX',
      zip: '77379',
      phone: '(832) 559-7160',
      hours: {
        'Monday-Thursday': '11:00 AM - 10:00 PM',
        'Friday-Saturday': '11:00 AM - 11:00 PM',
        'Sunday': '11:00 AM - 9:00 PM'
      },
      mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3448.8901123123123!2d-95.5262533!3d30.0568348!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x86473a7eadb6f0e3%3A0xb5f9dd5f5aa12797!2s21420%20Kuykendahl%20Rd%2C%20Spring%2C%20TX%2077379!5e0!3m2!1sen!2sus!4v1648132133358!5m2!1sen!2sus'
    }
  ];

  return (
    <div className="locations-page">
      <div className="locations-hero">
        <div className="locations-hero-content">
          <h1>Our Locations</h1>
          <p>Find your nearest Texas Craft Wings</p>
        </div>
      </div>

      <div className="locations-container">
        {locations.map((location, index) => (
          <div key={index} className="location-card">
            <div className="location-map">
              <iframe
                src={location.mapUrl}
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title={`Map of ${location.name}`}
              ></iframe>
            </div>
            <div className="location-info">
              <h2>{location.name}</h2>
              <div className="info-grid">
                <div className="info-section">
                  <h3>Address</h3>
                  <p>{location.address}</p>
                  <p>{location.city}, {location.state} {location.zip}</p>
                  <p className="phone">{location.phone}</p>
                  <a 
                    href={`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
                      `${location.address} ${location.city}, ${location.state} ${location.zip}`
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="directions-button"
                  >
                    Get Directions
                  </a>
                </div>
                <div className="info-section">
                  <h3>Hours</h3>
                  <div className="hours-list">
                    {Object.entries(location.hours).map(([days, hours], i) => (
                      <div key={i} className="hours-item">
                        <span className="days">{days}</span>
                        <span className="hours">{hours}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="location-actions">
                <button className="order-button">Order Online</button>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="contact-section">
        <div className="container">
          <h2>Questions or Feedback?</h2>
          <p>We'd love to hear from you! Contact us using the form below or call any of our locations.</p>
          <div className="contact-form">
            <div className="form-grid">
              <div className="form-group">
                <label htmlFor="name">Name</label>
                <input type="text" id="name" name="name" />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input type="email" id="email" name="email" />
              </div>
            </div>
            <div className="form-grid">
              <div className="form-group">
                <label htmlFor="phone">Phone</label>
                <input type="tel" id="phone" name="phone" />
              </div>
              <div className="form-group">
                <label htmlFor="location">Location</label>
                <select id="location" name="location">
                  <option value="">Select a location</option>
                  {locations.map((loc, index) => (
                    <option key={index} value={loc.name}>{loc.name}</option>
                  ))}
                </select>
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea id="message" name="message" rows="4"></textarea>
            </div>
            <button type="submit" className="submit-button">Send Message</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Locations;
